import { AfterViewInit, Component } from '@angular/core';
import { FspBorderPointsGridDataService } from './fsp-border-points-grid-data.service';
import { FspBorderPointsGridDto } from './fsp-border-points-grid-data-model';
import {
  getFspBorderPointsGridToolbarItems,
  fspBorderPointsGridColumns,
} from './fsp-border-points-grid-model';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { combineLatest, filter, map, Observable, takeWhile, tap } from 'rxjs';
import { FreeServicesParcelRequestGridDto } from '../fsp-parcel-request-grid/free-services-parcel-request-grid-data-model';
import { FreeServicesParcelRequestGridDataService } from '../fsp-parcel-request-grid/free-services-parcel-request-grid-data.service';
import { GkKendoGridComponent } from '../../../gk-kendo';
import { FreeServicesRequestListGridDataService } from '../../free-services-request-list-grid/free-services-request-list-grid-data.service';
import { FreeServicesRequestListGridDto } from '../../free-services-request-list-grid/free-services-request-list-grid-data-model';

@Component({
  selector: 'app-fsp-border-points-grid',
  templateUrl: '../../../gk-kendo/gk-kendo-grid/gk-kendo-grid.component.html',
  standalone: false,
})
export class FspBorderPointsGridComponent
  extends GkKendoGridComponent<FspBorderPointsGridDto>
  implements AfterViewInit
{
  constructor(
    public fspBorderPointsGridDataService: FspBorderPointsGridDataService,
    public freeServicesParcelRequestGridDataService: FreeServicesParcelRequestGridDataService,
    public freeServicesRequestListGridDataService: FreeServicesRequestListGridDataService,
  ) {
    super(fspBorderPointsGridDataService);
  }

  override topGridToolbarItems = getFspBorderPointsGridToolbarItems();
  override columns = fspBorderPointsGridColumns;
  override selectable: SelectableSettings = {
    enabled: true,
    mode: 'single',
  };
  override sortable = true;
  selectedParcelGridItem: FreeServicesParcelRequestGridDto;
  selectedRequestListGridItem: FreeServicesRequestListGridDto;

  override ngAfterViewInit(): void {
    this.subscribeToCombinedSelections();
  }

  private subscribeToCombinedSelections(): void {
    const parcel$ = this.subscribeToParcelListGridSelectedKeys();
    const request$ = this.subscribeToRequestListGridSelectedKeys();

    combineLatest([parcel$, request$])
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(([parcelItem, requestItem]) => {
        this.selectedParcelGridItem = parcelItem;
        this.selectedRequestListGridItem = requestItem;
        this.fetchGridData();
      });
  }

  subscribeToParcelListGridSelectedKeys(): Observable<FreeServicesParcelRequestGridDto> {
    return this.freeServicesParcelRequestGridDataService.$selection.pipe(
      takeWhile(() => this.isAlive),
      tap(() => {
        this.selectedParcelGridItem = undefined;
      }),
      filter(Boolean),
      map((selection) => selection.selectedRows[0].dataItem),
    );
  }

  subscribeToRequestListGridSelectedKeys(): Observable<FreeServicesRequestListGridDto> {
    return this.freeServicesRequestListGridDataService.$selection.pipe(
      takeWhile(() => this.isAlive),
      tap(() => {
        this.selectedRequestListGridItem = undefined;
      }),
      filter(Boolean),
      map((selection) => selection.selectedRows[0].dataItem),
    );
  }

  fetchGridData(): void {
    this.fspBorderPointsGridDataService.$loading.next(true);
    this.freeServicesParcelRequestGridDataService
      .fetchParcelDetailsFromApi(
        this.selectedRequestListGridItem.ZamowUuid,
        this.selectedParcelGridItem.KdzialkaUuid,
      )
      .subscribe((data) => {
        this.fspBorderPointsGridDataService.$loading.next(false);
        this.fspBorderPointsGridDataService.next({
          data: data.PunktyGraniczne,
          total: data.PunktyGraniczne.length,
        });
      });
  }
}
